'use client';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useDarkModeContext } from '../../hooks';
import { getDesignTokens } from '../../utils';

import type { FC, ReactNode } from 'react';

export interface DarkModeProps {
  children: ReactNode;
}

export const DarkMode: FC<DarkModeProps> = ({ children }) => {
  const { darkPalette } = useDarkModeContext();

  return (
    <ThemeProvider
      theme={(theme) => createTheme( getDesignTokens( 'dark', theme, darkPalette ) )}
    >
      {children}
    </ThemeProvider>
  );
};
